<template>
<div style="height: 400px;">
  <el-scrollbar>
    <div class="title-h4 title-bar">발신자 이름</div>
    <el-table class="mr-b25" :data="senderInfoTable">
      <el-table-column prop="keyword" label="예약어"></el-table-column>
      <el-table-column prop="value" label="설명"></el-table-column>
    </el-table>
    <div class="title-h4 title-bar">발신 연락 번호</div>
    <el-table class="mr-b25" :data="senderNumber">
      <el-table-column prop="keyword" label="예약어"></el-table-column>
      <el-table-column prop="value" label="설명"></el-table-column>
    </el-table>
    <div class="title-h4 title-bar">DB Type별 시간 함수</div>
    <el-table :data="dbTimeInfo">
      <el-table-column prop="keyword" label="예약어"></el-table-column>
      <el-table-column prop="value" label="설명"></el-table-column>
    </el-table>
  </el-scrollbar>
</div>
</template>

<script>
export default {
  name: 'WTableValueLegend',
  data() {
    return {
      senderNumber: [
        {
          keyword: '01. SMS_SENDER_TEL_NO',
          value: '0123456789',
        },
        {
          keyword: '02. SMS_RECEIVER_TEL_NO',
          value: '받는사람 연락 번호 - WatchAll 정보 동적 할당: 관리자 설정 정보',
        },
        {
          keyword: '03. SMS_RECEIVER_NAME_TEL_NO',
          value: '받는사람 계정 ID 연락번호 - WatchAll 정보 동적 할당: 관리자 설정 정보',
        },
        {
          keyword: '04. SMS_RECEIVER_TEL_NO_TYPE_A',
          value: '받는사람 연락 번호 - WatchAll 정보 동적 할당: 관리자 설정 정보 - TYPE1: 특수 문자 없는 타입(0123456789)',
        },
        {
          keyword: '05. SMS_RECEIVER_TEL_NO_PART1',
          value: '받는사람 연락 번호 - WatchAll 정보 동적 할당: 관리자 설정 정보 - TYPE2: 연락처 제일 앞 3자리 (012)',
        },
        {
          keyword: '06. SMS_RECEIVER_TEL_NO_PART2',
          value: '받는사람 연락 번호 - WatchAll 정보 동적 할당: 관리자 설정 정보 - TYPE2: 연락처 가운데 3~4자리 (345)',
        },
        {
          keyword: '07. SMS_RECEIVER_TEL_NO_PART3',
          value: '받는사람 연락 번호 - WatchAll 정보 동적 할당: 관리자 설정 정보 - TYPE2: 연락처 뒤에 4자리 (6789)',
        },
        {
          keyword: '08. SMS_MESSAGE',
          value: '메시지 - WatchAll 정보 동적 할당: 이벤트 발생 메시지',
        },
        {
          keyword: '09. SMS_MESSAGE_NOT_LIMIT',
          value: '80자 이상의 이벤트 메시지 전송 (최대 4000자)',
        },
        {
          keyword: '10. SMS_EVENT_NODE_IP',
          value: '이벤트 발생 장비 IP - WatchAll 정보 동적 할당: 이벤트 발생 메시지',
        },
        {
          keyword: '11. SMS_SEQ_ALARM_RESULT',
          value: 'SMS Sequence Alarm 실행 결과 - WatchAll 정보 동적 할당: SMS Alarm 정보 실행 결과',
        },
        {
          keyword: '12. SMS_ALARM_LEVEL',
          value: '이벤트 발생 레벨 정보 - WatchAll 정보 동적 할당: 이벤트 발생 레벨 정보',
        },
        {
          keyword: '13. SMS_SIMPLE_DATE_FORMAT',
          value: '현재 시간 정보 - WatchAll 정보 동적 할당',
        },
        {
          keyword: '14. SMS_INDEX',
          value: 'SMS_INDEX_QUERY를 이용하여 가져온 값을 할당 ( 값이 INTEGER일 경우 )',
        },
        {
          keyword: '15. SMS_INDEX_STR',
          value: 'SMS_INDEX_QUERY를 이용하여 가져온 값을 할당 ( 값이 STRING일 경우 )',
        },
        {
          keyword: '16. SMS_INDEX_QUERY',
          value: 'INDEX QUERY값을 할당',
        },
      ],
      senderInfoTable: [
        {
          keyword: 'SMS_SENDER_NAME',
          value: 'WatchAll',
        },
      ],
      dbTimeInfo: [
        {
          keyword: 'MSSQL',
          value: 'getdate()',
        },
        {
          keyword: 'MySQL',
          value: 'NOW()',
        },
        {
          keyword: 'Oracle',
          value: 'sysdate',
        },
        {
          keyword: 'Oracle 날짜 포맷형식',
          value: 'to_char(sysdate,\'yyyymmddHH24MMISS\')',
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/settings/operation/EventAlarmSettings/AlarmSettings/components/TableValueLegend.vue